const BASE_URL = 'https://iron-tracker.herokuapp.com';

export const API_URL = (slug) => `${BASE_URL}/${slug}`;
